module.exports = __webpack_public_path__ + "static/media/cl-logo.f7eb907f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/cl-logo.svg
// module id = 254
// module chunks = 0